export default "__VITE_ASSET__b931f56d__"